import { NgModule } from '@angular/core';
import 'Scripts/Angular/overrides.ts';
import { ActivatableOpacityBtn } from "sharedFeatures/activatable-opacity-btn";
import { BasePaneComponent } from "sharedFeatures/base-pane";
import {
    BillingDetailsBodyComponent, BillingDetailsComponent, BillingDetailsPaneComponent, BillingPaymentHistoryBodyComponent,
    BillingPaymentHistoryPaneComponent, BillingSubscriptionBodyComponent,
    BillingSubscriptionPaneComponent, BillingSubscriptionWinComponent, BuyPlanSlotsBodyComponent, BuyPlanSlotsPaneComponent
} from "sharedFeatures/billing";
import {
    ChangePaymentWinBodyComponent,
    ChangePaymentWinComponent
} from "sharedFeatures/change-payment-win";
import { ConfirmEditor, ConfirmEditorBodyComponent } from 'sharedFeatures/confirm-editor';
import { ConfirmRemoveFromTeamPopupBodyComponent, ConfirmRemoveFromTeamPopupComponent } from 'sharedFeatures/confirm-remove-from-team-popup';
import { ConfirmTeamOwnerPopupBodyComponent, ConfirmTeamOwnerPopupComponent } from "sharedFeatures/confirm-team-owner-popup";
import {
    DraggabledDirective, DropTargetDirective, FlowLayoutDirective, ListDropTargetDirective, NestableFormDirective,
    ReadonlyDirective, ResizableDirective, SpaceRowLayoutDirective, TestidGTMDirective
} from 'sharedFeatures/directives';
import { DowngradePopup, DowngradePopupBodyComponent } from "sharedFeatures/downgrade-popup";
import { FeedbackPopupBodyComponent, FeedbackPopupComponent, FeedbackSentBodyComponent, FeedbackSentComponent } from 'sharedFeatures/feedback-popup';
import {
    CheckboxComponent,
    ExpandMenuItemComponent,
    LinkComponent,
    RadioGroupComponent, ToggleControlComponent
} from "sharedFeatures/form";
import { GreenHint } from 'sharedFeatures/green-hint';
import { IndicatorComponent } from "sharedFeatures/indicator/indicator.component";
import { InviteTeamMemberPopupBodyComponent, InviteTeamMemberPopupComponent } from 'sharedFeatures/invite-team-member-popup';
import { MenuItemPopup, MenuItemPopupBodyComponent } from "sharedFeatures/menu-item-popup";
import {
    Xi2ProfitLossFormBodyComponent,
    Xi3BalanceSheetFormBodyComponent,
    Xi4DataAssociationsFormBodyComponent
} from "sharedFeatures/newplan-win";
import { SetupWarningPopup, SetupWarningPopupBody } from "sharedFeatures/newplan-win/setup-warning-popup";
import { RefreshFormBodyComponent, RefreshFormComponent } from 'sharedFeatures/refresh-form';
import { RemoveSharedUser, RemoveSharedUserBodyComponent } from 'sharedFeatures/remove-shared-user';
import { ReportsUnlockPopup, ReportsUnlockPopupBodyComponent } from 'sharedFeatures/reports-unlock-popup';
import { SaveClosePane } from "sharedFeatures/save-close-pane";
import { SharePlanPopup, SharePlanPopupBodyComponent } from 'sharedFeatures/share-plan-popup';
import {
    StartTrialWin,
    StartTrialWinBodyComponent
} from "sharedFeatures/start-trial-win";
import { SubmenuDropdownPopupComponent } from 'sharedFeatures/submenu';
import {
    SubscriptionCancelWinBodyComponent, SubscriptionCancelWinComponent
} from "sharedFeatures/subscription-cancel-win";
import {
    SubscriptionExpiredWinBodyComponent, SubscriptionExpiredWinComponent
} from "sharedFeatures/subscription-expired-win";
import { SubscriptionLapsePopupBodyComponent, SubscriptionLapsePopupComponent } from 'sharedFeatures/subscription-lapse-popup';
import {
    SubscriptionSwitchWinBodyComponent, SubscriptionSwitchWinComponent
} from "sharedFeatures/subscription-switch-win";
import { TabLinkComponent } from 'sharedFeatures/tab-link/tab-link.component';
import { TrialTimerComponent } from "sharedFeatures/trial-timer";
import {
    SwitchLinkComponent,
    UpgradeWin
} from "sharedFeatures/upgrade-win";
import { UpperDropDownMenuComponent } from "sharedFeatures/upperDropDownMenu";
import { WindowComponent } from 'sharedFeatures/window';
import { XeroLinksComponent } from 'sharedFeatures/xeroLinks';
import { SharedGuiSmallModule } from 'sharedGuiSmall/sharedGuiSmall.module';
import { RedirectGlobalService } from '../../sharedGuiSmall/sharedServices/redirectGlobal.service';
import { MinValuePipe } from '../pipes/minvalue.pipe';
import { SafeHtmlPipe } from '../pipes/safehtml.pipe';
import { BuyPlanWinBodyComponent, BuyPlanWinComponent } from './components/buy-plans-win';
import { infoPopUpComponent } from './components/infoPopUp/infoPopUp.component';
import { MiniUpgradePopupBodyComponent } from './components/mini-upgrade-popup/mini-upgrade-popup-body.component';
import { MiniUpgradePopup } from './components/mini-upgrade-popup/mini-upgrade-popup.component';
import { NewCompanyWin, NewCompanyWinBodyComponent } from './components/new-company-win';
import { MoveBtnComponent } from "./components/newplan-win/move-btn/move-btn.component";
import { ScrollComponent } from './components/scroll/scrolldiv.component';
import { SmartTextPopupBodyComponent, SmartTextPopupComponent } from './components/smart-text-popup';
import { SmartTextComponent } from './components/smart-text/smart-text.component';
import { TimeoutPopupBodyComponent } from './components/timeout-popup/timeout-popup-body.component';
import { TimeoutPopup } from './components/timeout-popup/timeout-popup.component';
import { TimeoutDemoPopupBodyComponent } from './components/timeoutdemo-popup/timeoutdemo-popup-body.component';
import { TimeoutDemoPopup } from './components/timeoutdemo-popup/timeoutdemo-popup.component';
import { TimeoutGuestPopupBodyComponent } from './components/timeoutguest-popup/timeoutguest-popup-body.component';
import { TimeoutGuestPopup } from './components/timeoutguest-popup/timeoutguest-popup.component';
import { UpgradeComponent } from './components/upgrade';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        UpperDropDownMenuComponent,
        ActivatableOpacityBtn,
        WindowComponent,
        ExpandMenuItemComponent,
        LinkComponent,
        ToggleControlComponent,
        DropTargetDirective,
        TestidGTMDirective,
        FlowLayoutDirective,
        SpaceRowLayoutDirective,
        NestableFormDirective,
        ResizableDirective,
        ReadonlyDirective,
        TrialTimerComponent,
        MenuItemPopupBodyComponent,
        MenuItemPopup,
        SwitchLinkComponent,
        UpgradeWin,
        StartTrialWin,
        DowngradePopupBodyComponent,
        DowngradePopup,
        ConfirmTeamOwnerPopupBodyComponent,
        ConfirmTeamOwnerPopupComponent,
        SubscriptionLapsePopupBodyComponent,
        SubscriptionLapsePopupComponent,
        ConfirmRemoveFromTeamPopupBodyComponent,
        ConfirmRemoveFromTeamPopupComponent,
        InviteTeamMemberPopupBodyComponent,
        InviteTeamMemberPopupComponent,
        SharePlanPopupBodyComponent,
        SharePlanPopup,
        RemoveSharedUser,
        RemoveSharedUserBodyComponent,
        ConfirmEditor,
        ConfirmEditorBodyComponent,
        ReportsUnlockPopup,
        TimeoutPopupBodyComponent,
        TimeoutPopup,
        TimeoutGuestPopupBodyComponent,
        TimeoutGuestPopup,
        TimeoutDemoPopupBodyComponent,
        TimeoutDemoPopup,
        ReportsUnlockPopupBodyComponent,
        RefreshFormComponent,
        RefreshFormBodyComponent,
        FeedbackPopupComponent,
        FeedbackSentComponent,
        FeedbackSentBodyComponent,
        GreenHint,
        SubmenuDropdownPopupComponent,
        SetupWarningPopup,
        IndicatorComponent,
        SubscriptionExpiredWinComponent,
        SubscriptionExpiredWinBodyComponent,
        SubscriptionSwitchWinComponent,
        SubscriptionSwitchWinBodyComponent,
        SubscriptionCancelWinComponent,
        SubscriptionCancelWinBodyComponent,
        BasePaneComponent,
        BillingDetailsComponent,
        BillingDetailsBodyComponent,
        BillingDetailsPaneComponent,
        BillingSubscriptionBodyComponent,
        BillingSubscriptionPaneComponent,
        BillingPaymentHistoryBodyComponent,
        BillingPaymentHistoryPaneComponent,
        BillingSubscriptionWinComponent,
        BuyPlanSlotsBodyComponent,
        BuyPlanSlotsPaneComponent,
        ChangePaymentWinBodyComponent,
        ChangePaymentWinComponent,
        NewCompanyWin,
        MiniUpgradePopup,
        MiniUpgradePopupBodyComponent,
        SmartTextComponent,
        SmartTextPopupBodyComponent,
        SmartTextPopupComponent,
        BuyPlanWinComponent,
        BuyPlanWinBodyComponent,
    ],
    imports: [
        TranslateModule.forChild(),
        SharedGuiSmallModule,
        NewCompanyWinBodyComponent,
        MoveBtnComponent,
        SetupWarningPopupBody,
        SaveClosePane,
        XeroLinksComponent,
        TabLinkComponent,
        FeedbackPopupBodyComponent,
        Xi4DataAssociationsFormBodyComponent,
        Xi3BalanceSheetFormBodyComponent,
        Xi2ProfitLossFormBodyComponent,
        StartTrialWinBodyComponent,
        ListDropTargetDirective,
        DraggabledDirective,
        RadioGroupComponent,
        CheckboxComponent,
        infoPopUpComponent,
        ScrollComponent,
        SafeHtmlPipe,
        MinValuePipe,
        UpgradeComponent
    ],
    exports: [
        SharedGuiSmallModule,
        infoPopUpComponent,
        UpperDropDownMenuComponent,
        WindowComponent,
        CheckboxComponent,
        ActivatableOpacityBtn,
        ExpandMenuItemComponent,
        LinkComponent,
        RadioGroupComponent,
        ToggleControlComponent,
        DraggabledDirective,
        DropTargetDirective,
        ListDropTargetDirective,
        TestidGTMDirective,
        FlowLayoutDirective,
        SpaceRowLayoutDirective,
        NestableFormDirective,
        ResizableDirective,
        ReadonlyDirective,
        TrialTimerComponent,
        MenuItemPopup,
        UpgradeWin,
        StartTrialWin,
        StartTrialWinBodyComponent,
        SwitchLinkComponent,
        DowngradePopupBodyComponent,
        DowngradePopup,
        ConfirmTeamOwnerPopupBodyComponent,
        ConfirmTeamOwnerPopupComponent,
        SubscriptionLapsePopupBodyComponent,
        SubscriptionLapsePopupComponent,
        ConfirmRemoveFromTeamPopupBodyComponent,
        ConfirmRemoveFromTeamPopupComponent,
        InviteTeamMemberPopupBodyComponent,
        InviteTeamMemberPopupComponent,
        SharePlanPopupBodyComponent,
        SharePlanPopup,
        RefreshFormComponent,
        RefreshFormBodyComponent,
        BasePaneComponent,
        Xi2ProfitLossFormBodyComponent,
        Xi3BalanceSheetFormBodyComponent,
        Xi4DataAssociationsFormBodyComponent,
        FeedbackPopupComponent,
        FeedbackPopupBodyComponent,
        FeedbackSentComponent,
        FeedbackSentBodyComponent,
        GreenHint,
        TabLinkComponent,
        XeroLinksComponent,
        SaveClosePane,
        SetupWarningPopup,
        SetupWarningPopupBody,
        MoveBtnComponent,
        IndicatorComponent,
        NewCompanyWinBodyComponent,
        NewCompanyWin,
        ScrollComponent,
        SafeHtmlPipe,
        MinValuePipe,
        SmartTextComponent,
        SmartTextPopupBodyComponent,
        SmartTextPopupComponent,
        BuyPlanWinComponent,
        BuyPlanWinBodyComponent
    ],
    providers: [RedirectGlobalService]
})

export class SharedGuiModule {
}